import { IsArray, IsNotEmpty, IsNumber } from 'class-validator';

export class PoliticaUsuarioCriarDto {
  @IsArray()
  @IsNumber({}, { each: true })
  @IsNotEmpty()
  politicasIds: number[];
}
